{
    "Accessibility menu": "Хүртээмжийн цэс",
    "Close": "Хаах",
    "Content adjustments": "Агуулгын тохируулга",
    "Navigation adjustments": "Навигацийн тохируулга",
    "Text Align": "Текстийн зэрэгцүүлэлт",
    "Align Left": "Зүүн талд зэрэгцүүлэх",
    "Align Center": "Голд байрлуулах",
    "Align Right": "Баруун талд байрлуулах",
    "Adjust Font Size": "Фонтын хэмжээг тохируулах",
    "Highlight Title": "Гарчгийг онцлох",
    "Highlight Links": "Холбоосуудыг онцлох",
    "Readable Font": "Уншихад хялбар фонт",
    "Colour adjustments": "Өнгөний тохируулга",
    "Dark Contrast": "Харанхуй ялгарал",
    "Light Contrast": "Гэрэлтэй ялгарал",
    "High Contrast": "Өндөр ялгарал",
    "High Saturation": "Өндөр ханалт",
    "Low Saturation": "Бага ханалт",
    "Monochrome": "Нэг өнгө",
    "Tools": "Хэрэгслүүд",
    "Reading Guide": "Уншлагын заагч",
    "Big Cursor": "Том курсор",
    "Increase Font Size": "Фонтын хэмжээг нэмэгдүүлэх",
    "Decrease Font Size": "Фонтын хэмжээг багасгах",
    "Letter Spacing": "Үсгийн хоорондын зай",
    "Line Height": "Мөрийн өндөр",
    "Font Weight": "Фонтын жин",
    "Dyslexia Font": "Дислекси фонт",
    "Language": "Хэл",
    "Accessibility widget": "Хүртээмжийн цэсийг нээх",
    "Accessibility Profiles": "Хүртээмжийн профайлууд",
    "Cognitive Disability": "Танин мэдэхүйн хөгжлийн бэрхшээл",
    "Seizure Safe": "Тархины цочролд аюулгүй",
    "Accessibility statement": "Хүртээмжийн мэдэгдэл",
    "ADHD": "Анхаарал сулрал",
    "Low Vision": "Хараа сул",
    "Pause Animations": "Анимацийг зогсоох",
    "Animation paused": "Анимацийг түр зогсоосон",
    "Reset all settings": "Тохиргоог дахин тохируулах",
    "Shortcut:": "Товчлол:",
    "Epilepsy Safe Mode": "Уналт өвчинд аюулгүй горим",
    "Mute sounds": "Дууг хаах",
    "Page read": "Хуудсыг унших",
    "Page read controls": "Хуудас унших удирдлага",
    "Pause": "Түр зогсоох",
    "Resume": "Үргэлжлүүлэх",
    "Stop": "Зогсоох",
    "Settings": "Тохиргоо",
    "Speed": "Хурд",
    "Voice": "Дуу хоолой",
    "Close accessibility menu": "Хүртээмжийн цэсийг хаах",
    "Back to accessibility menu": "Хүртээмжийн цэс рүү буцах",
    "Search languages": "Хэл хайх",
    "Selected language": "Сонгосон хэл",
    "View accessibility statement (opens in new window)": "Хүртээмжийн мэдэгдлийг үзэх (шинэ цонхонд нээгдэнэ)",
    "Visit CookieYes website (opens in new window)": "CookieYes вэбсайтад зочлох (шинэ цонхонд нээгдэнэ)",
    "Reset all accessibility settings to default": "Бүх хүртээмжийн тохиргоог анхны утгад нь сэргээх"
}
